module.exports = __webpack_public_path__ + "img/dattocon-homepage.7db7fef3.jpg";